<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template slot="dateRangeSearch" slot-scope="scope">
    <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.timeStart"
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.timeEnd"
              type="date"
              value-format="yyyy-MM-dd 23:59:59"
              range-separator="到"
            
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carmonthchangelog_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/carv2/carmonthchangelog';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      firstDisplayFlag: false,
      reWrite: false,
      form: {},
      spaceList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      tempSpaceId: '',
      option: {
        height: 'auto',
        //calcHeight: '30',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        menu: false,
        columnBtn: false,
        searchMenuSpan: 6,
        align: 'center',
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            search: true,
            clearable: false,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
          },
          {
            label: '同步时间',
            prop: 'createTime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '同步时间',
            prop: 'dateRange',
            search: true,
            searchslot:true,
            searchRange: true,
            hide: true,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            width: 150,
          },
          {
            label: '车牌号',
            prop: 'carNo',
            search: true,
          },
          {
            label: '客户姓名',
            prop: 'customerName',
            search: true,
          },
          {
            label: '租赁起期',
            prop: 'buyStartTime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
          },
          {
            label: '租赁止期',
            prop: 'buyEndTime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
          },
          {
            label: '车辆分类',
            span: 8,
            type: 'select',
            search: true,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_class',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            prop: 'carClass',
          },
          {
            label: '车辆类型',
            span: 8,
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
            prop: 'carType',
            rules: [
              {
                required: true,
                message: '请选择车辆类型',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthchangelog_add, false),
        viewBtn: this.vaildData(this.permission.carmonthchangelog_view, false),
        delBtn: this.vaildData(this.permission.carmonthchangelog_delete, false),
        editBtn: this.vaildData(this.permission.carmonthchangelog_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.option.column[0].dicData = data.data;
        this.option.column[0].searchValue = this.spaceList[0].id;
        this.query.spaceId = this.spaceList[0].id;
        this.tempSpaceId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
    this.initStatusList();
    this.initCartypeList();
    // this.initDateEndRange();
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query .spaceId= '';
      this.query .carNo= '';
      this.query .customerName= '';
      this.query .carClas= '';
      this.query .carType= '';
      this.query .timeStart= '';
      this.query .timeEnd=''
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query .spaceId= params.spaceId;
      this.query .carNo= params.carNo;
      this.query .customerName= params.customerName;
      this.query .carClas= params.carClas;
      this.query .carType= params.carType;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      
      //如果加载列表时spaceId为空，则将spaceId置为当前的第一个车场
      if (this.query.spaceId == undefined || this.query.spaceId == '') {
        this.query.spaceId = this.tempSpaceId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.spaceId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style></style>
